import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Divider, Form, Input, Modal, notification, Row, Space, Spin, Upload } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { RootDispatch } from '../../app/store'
import React from 'react'
import { DateRangeMSFX, DateRangeType, DateSelect, getDateRange } from '../../compnents/form/DateSelect'
import { EditableList } from '../../compnents/list/EditableList'
import { OneClickWarehousingColumns, PurchaseDetailsInformationcolumns } from './columns'
import styles from './putstorage.module.css'
import { PurchaseInventoryEntryCheckQuery, PurchaseInventoryEntryCheckRef } from './purchaseInventoryEntryCheckQuery'
import { getBindMSFXListAsync, getOneClickStorageAsync, getSureImportListAsync } from './putstorageSlice'
import moment from 'moment'
import { DateTimeFormat, DateTimeFormatSimple, DateTimeFormatSimpleOnly, DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import { ExclamationCircleFilled, LeftOutlined, RightOutlined } from '@ant-design/icons'
import { BillCodeDetailModal } from './billCodeDetailModal'
import { useHistory, useLocation } from 'react-router-dom'
import { Checks } from '../../models/setting'
import { selectSettings } from '../user/setting/settingSlice'

export const OneClickWarehousingModal = (props: {
  station?: any
  tockSalesUploadCategory?: string //判断是否为进销存业务
  visible?: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const history = useHistory()

  const location: any = useLocation()

  const settings = useSelector(selectSettings) 

  const formRef = React.useRef<PurchaseInventoryEntryCheckRef>(null)

  const [buttonFlag, setButtonFlag] = useState<any>(0) //1 导入后

  const [timeHead, timeTail] = getDateRange(DateRangeType.RecentSevenDays)

  const [params, setParams] = useState<any>({
    page: 1,
    pageSize: 10,
    beginDate: moment(timeHead).format(DateTimeFormatSimple),
    endDate: moment(timeTail).format(DateTimeFormatSimple),
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [pageLoading, setPageLoading] = useState(false)

  const [selectIds, setSelectIds] = useState<any>([])

  const [selectRow, setSelectRow] = useState<any>([])

  const [billCodeDetailVisible, setBillCodeDetailVisible] = useState(false)

  const [detailList, setDetailList] = useState<any>([]) //导入成功后的页面数据

  const [importLoading, setImportLoading] = useState(false) //导入loading

  const [detailParam, setDetailParam] = useState<any>({}) //发货单号一致的明细参数

  useEffect(() => {
    if (props?.visible) {
      setButtonFlag(0)
    } else {
      resetSelect()
      form.resetFields()
      setParams({
        page: 1,
        pageSize: 10,
        beginDate: moment(timeHead).format(DateTimeFormatSimple),
        endDate: moment(timeTail).format(DateTimeFormatSimple),
      })
    }
  }, [props.visible])

  const resetSelect = () => {
    setSelectIds([])
    setSelectRow([])
  }

  useEffect(() => {
    if (props?.visible) {
      if (params?.beginDate) {
        getPageList()
      }
    }
  }, [props?.visible, params])

  const getPageList = () => {
    setPage({
      total: 0,
      current: params?.page || 1,
      size: params?.pageSize || 10,
      items: [],
    })
    setPageLoading(true)
    dispatch(getBindMSFXListAsync({
      ...params,
      nextCursorToken: page?.nextCursorToken,
      beginDate: params?.beginDate ? moment(params?.beginDate).format(DateTimeFormatSimpleOnly) : moment(timeHead).format(DateTimeFormatSimpleOnly),
      endDate: params?.endDate ? moment(params?.endDate).format(DateTimeFormatSimpleOnly) : moment(timeTail).format(DateTimeFormatSimpleOnly),
    }))
      .then(unwrapResult)
      .then((v: any) => {
        setPageLoading(false)
        setPage({
          hasNext: v?.hasNext,
          nextCursorToken: v?.nextCursorToken,
          total: v?.totalNum,
          current: params?.page || 1,
          size: params?.pageSize || 10,
          items: v?.orders || [],
        })
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  // 确定导入
  const sureImport = () => {
    setImportLoading(true)
    const params = selectRow?.map((v: any) => {
      return {
        billCode: v?.billCode,
        fromRefUserId: v?.fromRefUserId,
        toRefUserId: v?.toRefUserId,
      }
    })
    dispatch(getSureImportListAsync(params))
      .then(unwrapResult)
      .then((v: any) => {
        const data = {
          ...v,
          billCodeGroupList: v?.billCodeGroupList?.map((v: any) => {
            return {
              ...v,
              items: v?.items?.map((item: any) => {
                return {
                  ...item,
                  localProdName: item?.matchedFlag ? item?.localProdName : item.name,
                }
              }),
            }
          }),
        }

        setDetailList(data || [])
        notification.success({
          message: '导入成功',
        })
        setButtonFlag(1)
        // resetData()
      })
      .finally(() => {
        setImportLoading(false)
      })
  }

  const resetData = () => {
    setSelectIds([])
    setSelectRow([])
  }

  // 最终保存
  const submitOneClickStorage = (params: any) => {
    if(!detailList?.billCodeGroupList?.length) {
      notification.info({
        message: '请先导入数据',
      })
      return
    }
    const submitParams = {
      ...params,
      ybUploadFlag: undefined,
      billCodeGroupList: detailList?.billCodeGroupList?.map((v: any) => {
        return {
          ...v,
          items: v?.items?.map((item: any) => {
            return {
              ...item,
              name: item?.localProdName,
              formatter: undefined,
              retailPrice: item?.retailPrice || 0,
            }
          }),
        }
      }),
    }
    setImportLoading(true)
    dispatch(getOneClickStorageAsync(submitParams))
      .then(unwrapResult)
      .then((v: any) => {
        notification.success({
          message: "操作成功",
        });
        history.push({
          pathname: '/putList',
          state: {
            station: props?.station,
            tockSalesUploadCategory:
              props?.tockSalesUploadCategory,
            category:
              props?.tockSalesUploadCategory ||
              location.state.category,
            selectId: v?.tenantInventoryReceiptsId,
          },
        })
        props?.onCancel()
        resetData()
      })
      .finally(() => {
        setImportLoading(false)
      })
  }

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
   const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const model = item.model ? item.model + '/' : ''
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    
    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
       // 包装规格  +  剂型 +  生产厂家  
        return  packSpec + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 +  型号 +  生产厂家 
        return packSpec + '/' + model + tenantSupplierName
      } else {
        // 包装规格 +  生产厂家
        return packSpec + '/' + tenantSupplierName
      }
    } else {
      if (materialsCategory == '0') {
        // 包装规格 + 包装单位(账簿) +  剂型 +  生产厂家  
        return  packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 + 包装单位(账簿) +  型号 +  生产厂家  
        return  packSpec + '/' + accountUnit + '/' + model + tenantSupplierName
      } else {
        // 包装规格 + 包装单位(账簿) +  生产厂家
        return packSpec + '/' + accountUnit + '/' + tenantSupplierName
      }
    }
  }
  return (
    <>
      <Modal
        width={1450}
        className={styles.modalContent}
        title={buttonFlag == 1 ? '采购入库单' : '一键导入（码上放心）'}
        visible={props.visible}
        footer={null}
        centered
        maskClosable={false}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
        destroyOnClose
      >
        {
          buttonFlag == 1 ? (
            <div style={{ height: '580px', overflowY: 'auto' }}>
              <PurchaseInventoryEntryCheckQuery
                ref={formRef}
                detailList={detailList}
                category={1}
                onValueChange={((v: any) => {
                  const params = {
                    ...detailList,
                    ...v,
                  }
                  setDetailList(params)
                  submitOneClickStorage(params)
                })}
              ></PurchaseInventoryEntryCheckQuery>
              <Divider></Divider>
              <Row className={styles.flexCenter}>
                <div className={styles.title}>采购明细</div>
                <div className={styles.subTitle}>
                  {/* <span>（药品名称为橙色字的是未匹配上，可点击药品名称选择目录进行匹配，如尚未创建目录，请先去</span>
                  <span className={styles.subTitleLink} onClick={(() => {
                    window.open(`/storage/station?station=${5}`, '_blank')
                  })}>创建目录</span> 
                  <span>）</span>*/}
                  <span style={{ color: '#FA8714' }}>（药品名称为橙色字的是未匹配，可点击药品名称选择目录进行匹配，如没有可匹配的目录则点击新增目录去快捷创建目录）</span>
                </div>
              </Row>
              <div style={{ marginBottom: '20px', width: '100%' }}>
                {detailList?.billCodeGroupList?.map((v: any, index?: any) => {
                  return (
                    <div
                      key={v?.webIdCode}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}
                    >
                      <div
                        className={styles.listTitle}
                        key={v?.webIdCode}
                        style={{

                        }}
                      >
                        <div>供应商：{v?.entSendName}，发货时间：{v?.storeOutDate ? moment(v?.storeOutDate).format(DateTimeFormatSimpleOnlyOne) : '-'}，码上放心发货单号：{v?.billCode}</div>
                        <Button
                          onClick={(() => {
                            Modal.confirm({
                              centered: true,
                              title: '确认操作',
                              content: (
                                <div>
                                  <ExclamationCircleFilled
                                    style={{ color: '#FFAE55', fontSize: 18 }}
                                  />
                                  &nbsp;是否确认删除该单据？
                                </div>
                              ),
                              okText: '确认',
                              cancelText: '取消',
                              icon: null,
                              onOk: () => {
                                const data = {
                                  ...detailList,
                                  billCodeGroupList: detailList?.billCodeGroupList?.filter((item: any) => item?.billCode != v?.billCode)
                                }
                                setDetailList(data)
                              },
                            })
                          })}><span style={{ color: 'red' }}>删除</span></Button>
                      </div>
                      <EditableList
                        key={index}
                        style={{
                          flex: 1,
                          overflow: 'auto',
                          border: '1px solid #f0f0f0',
                          borderBottom: 'none',
                        }}
                        pagination={false}
                        page={{
                          current: 1,
                          size: 10,
                          total: 0,
                          items: v?.items,
                        }}
                        rowKey={(m) => m?.webIdCode}
                        size='small'
                        columns={
                          PurchaseDetailsInformationcolumns(
                            (text: string, t: any, tt?: any) => {
                              if (text == 'edit') {
                                let params: any = {};
                                if (tt == 'batchNoChange' || tt == 'retailPriceChange' || tt == 'unitPriceChange') {

                                  const nextUnitPrice = tt == 'unitPriceChange' ? (t.next?.unitPrice ? Number(t.next.unitPrice) : 0) : (t.prev?.unitPrice ? Number(t.prev.unitPrice) : 0);
                                  const nextRetailPrice = tt == 'retailPriceChange' ? (t.next?.retailPrice ? Number(t.next.retailPrice) : 0) : (t.prev?.retailPrice ? Number(t.prev.retailPrice) : 0);
                                  const nextBatchNo = tt == 'batchNoChange' ? (t.next?.batchNo ? t.next.batchNo : '') : (t.prev?.batchNo ? t.prev.batchNo : '');

                                  params = {
                                    ...t.prev,
                                    unitPrice: nextUnitPrice,
                                    retailPrice: nextRetailPrice,
                                    batchNo: nextBatchNo,
                                    totalPrice: (t.prev?.count || 0) * nextUnitPrice,
                                  }
                                } else if (tt == 'selectChange') {

                                  const traceableCodeList = t.prev.traceableCodeList;
                                  const name = t.prev?.name;
                                  const displaySpec = t.prev?.displaySpec;
                                  const count = t.prev?.count;
                                  const approvalNumber = t.prev?.approvalNumber;
                                  const batchNo = t.prev.batchNo;
                                  const productDate = t.prev.productDate;
                                  const deadline = t.prev.deadline;
                                  const totalPrice = (t.prev?.count || 0) * t.next?.unitPrice;

                                  params = {
                                    ...t.prev,
                                    ...t.next,
                                    traceableCodeList: traceableCodeList,
                                    name: name,
                                    displaySpec: displaySpec,
                                    count: count,
                                    approvalNumber: approvalNumber,
                                    batchNo: batchNo,
                                    productDate: productDate,
                                    deadline: deadline,
                                    totalPrice: totalPrice,
                                    localProdName: t?.next?.name,
                                    localDisplaySpec: getProcuctInfo(t?.next),
                                    matchedFlag: t?.next?.no ? true : t?.prev?.matchedFlag
                                  }
                                }

                                const list = {
                                  ...detailList,
                                  billCodeGroupList: detailList?.billCodeGroupList?.map((val: any) => {
                                    // 如果当前行的 webIdCode 与修改行的 webIdCode 一致，就用新改好的值顺序不变
                                    return {
                                      ...val,
                                      items: val?.items?.map((i: any) => {
                                        return i?.webIdCode == params?.webIdCode
                                          ? { ...i, ...params }
                                          : i
                                      })
                                    }
                                  })
                                }
                                setDetailList(list)
                              }
                            },
                            (text: string, t: any) => {
                              if (text == 'delete') {
                                Modal.confirm({
                                  centered: true,
                                  title: '确认操作',
                                  content: (
                                    <div>
                                      <ExclamationCircleFilled
                                        style={{ color: '#FFAE55', fontSize: 18 }}
                                      />
                                      &nbsp;是否确认删除该药品？
                                    </div>
                                  ),
                                  okText: '确认',
                                  cancelText: '取消',
                                  icon: null,
                                  onOk: () => {
                                    const data = {
                                      ...detailList,
                                      billCodeGroupList: detailList?.billCodeGroupList?.map((val: any) => {
                                        return {
                                          ...val,
                                          items: val?.items?.filter((i: any) => i?.webIdCode != t?.webIdCode)
                                        }
                                      })?.filter((val: any) => val?.items?.length > 0)
                                    }
                                    setDetailList(data)
                                  },
                                })
                              }
                            })
                        }
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          ) : (
            <div style={{ height: '580px', overflowY: 'auto' }}>
              <Form
                form={form}
                onFinish={(values) => {
                  if (!values?.timeHead && values?._dateRange == 6) {
                    return
                  }
                  const data = {
                    ...values,
                    beginDate: values?.timeHead ? values?.timeHead : timeHead,
                    endDate: values?.timeHead ? values?.timeTail : timeTail,
                    timeHead: undefined,
                    timeTail: undefined,
                  }
                  setParams({ ...params, ...data, page: 1 })
                  resetSelect()
                }}
              >
                <Row style={{ marginTop: 10, marginBottom: 20 }} justify='space-between'>
                  <Space>
                    <Form.Item noStyle name='entName'>
                      <Input
                        autoComplete='off'
                        maxLength={20}
                        placeholder='供应商名称'
                        style={{ width: '14rem' }}
                        allowClear
                        onChange={() => {
                          form.submit()
                        }}
                      />
                    </Form.Item>
                    <DateSelect
                      allowClear={false}
                      style={{ width: '8.5rem' }}
                      labelPrefix=''
                      namePrefix='time'
                      options={DateRangeMSFX}
                      placeholder='时间'
                      initialValue={DateRangeType.RecentSevenDays}
                      disabledDate={(current: any) => {
                        // 禁用今天之后的日期
                        const today = moment().endOf('day');
                        // 最多只能选择近三个月内的日期
                        const threeMonthsAgo = moment().subtract(3, 'months').startOf('day');
                        return current && (current > today || current < threeMonthsAgo);
                      }}
                      onChange={() => {
                        form.submit()
                      }}
                    />
                    <Button
                      loading={pageLoading}
                      type='primary'
                      onClick={() => {
                        form.submit()
                      }}
                    >
                      查询
                    </Button>
                    <span style={{ color: '#666', fontSize: 15, marginLeft: "20px" }}>
                      注：发货单号为灰色则表示该单据已导入过
                    </span>
                  </Space>
                </Row>
              </Form>
              <EditableList
                scroll={{
                  y: '400px',
                  x: '1000px'
                }}
                style={{
                  width: '100%',
                  height: '81%',
                  overflow: 'hidden',
                }}
                rowKey={(m) => m?.billCode}
                loading={pageLoading}
                pagination={false}
                page={{
                  current: params.page,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                columns={OneClickWarehousingColumns(
                  params?.pageSize || 10 * (params?.page || 1 - 1) || 1,
                  (r: any) => {
                    setBillCodeDetailVisible(true)
                    setDetailParam([{
                      billCode: r?.billCode,
                      fromRefUserId: r?.fromRefUserId,
                      toRefUserId: r?.toRefUserId,
                    }])
                  }
                )}
                onRow={(record) => ({
                  onClick: () => {
                    let data = []
                    let selectedRowsData = []
                    if (!selectIds.includes(record.billCode.toString())) {
                      // 置灰行不可通过点击行勾选，与 checkbox 行为一致
                      if (
                        selectRow.length > 0 &&
                        record.fromEntName !== selectRow[0]?.fromEntName
                      ) {
                        return
                      }
                      if (selectIds.length >= 30) {
                        notification.info({
                          message: '一次最多选择30个单据',
                        })
                        return
                      }
                      data = [record?.billCode, ...selectIds]
                      selectedRowsData = [record, ...selectRow]?.flat(1)
                    } else {
                      data = selectIds.filter((v: any) => v != record?.billCode)
                      selectedRowsData = selectRow.filter(
                        (v: any) => v?.billCode != record?.billCode
                      )
                    }
                    setSelectIds(data)
                    setSelectRow(selectedRowsData)
                  },
                })}
                rowSelection={{
                  selectedRowKeys: selectIds,
                  hideSelectAll: true, // 隐藏表头全选按钮
                  // 根据第一个已选供应商过滤可选行
                  getCheckboxProps: (record) => {
                    // 没有选中任何行时，全部可勾选
                    if (!selectRow || selectRow.length === 0) {
                      return {}
                    }
                    // 取第一个已选行的供应商
                    const firstSupplier = selectRow[0]?.fromEntName
                    // 当前行供应商与第一个不一致时禁用勾选
                    return {
                      disabled: record?.fromEntName !== firstSupplier,
                    }
                  },
                  onSelect: (record, selected, selectedRows) => {
                    let data = []
                    let selectedRowsData = []
                    if (selected) {
                      if (selectIds.length >= 30) {
                        notification.info({
                          message: '一次最多选择30个单据',
                        })
                        return
                      }
                      data = [record?.billCode, ...selectIds]
                      selectedRowsData = [record, ...selectRow]?.flat(1)
                    } else {
                      data = selectIds.filter((v: any) => v != record?.billCode)
                      selectedRowsData = selectRow.filter(
                        (v: any) => v?.billCode != record?.billCode
                      )
                    }
                    setSelectIds(data)
                    setSelectRow(selectedRowsData)
                  },
                }}
                onChangePage={(current: any, size: any) => {
                  setParams({
                    ...params,
                    page: current,
                    pageSize: size || 10,
                  })
                }}
              />
              <Row className={styles.iconContent}>
                <Button disabled={params.page === 1}
                  onClick={() => {
                    setParams({
                      ...params,
                      page: params.page - 1,
                    })
                  }}>
                  <LeftOutlined className={styles.icon} />
                </Button>
                <Button disabled={!page.hasNext}
                  onClick={() => {
                    setParams({
                      ...params,
                      page: params.page + 1,
                    })
                  }}>
                  <RightOutlined className={styles.icon} />
                </Button>
              </Row>
            </div>
          )
        }
        <Row className={styles.footer} style={{ position: 'relative' }}>
          <Space>
            <Button
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
            {buttonFlag == 1 ? (
              <>
                <Button
                  type='primary'
                  onClick={() => {
                    setButtonFlag(0)
                  }}
                >
                  返回上一步
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button
              type='primary'
              loading={importLoading}
              disabled={buttonFlag == 1 ? false : selectIds.length ? false : true}
              onClick={() => {
                if (buttonFlag == 0) {
                  sureImport()
                } else {
                  const list = detailList?.billCodeGroupList?.map((v: any) => v?.items)?.flat(1)?.filter((item: any) => {
                    return !item?.matchedFlag
                  })
                  if (list?.length) {
                    notification.info({
                      message: '还有待匹配的药品，请先去匹配',
                    })
                  } else {
                    formRef?.current?.save();
                  }
                }
              }}
            >
              {buttonFlag == 1 ? '保存' : '确定导入'}
            </Button>
          </Space>
          {buttonFlag == 1 ? (
            <></>
          ) : (
            <>
              <Col span={24} style={{ position: 'absolute', left: 15, }}>选中单据：{selectIds.length}条</Col>
            </>
          )}
        </Row>
      </Modal>
      {/* 发货单号一致的明细 */}
      <BillCodeDetailModal
        detailParam={detailParam}
        visible={billCodeDetailVisible}
        onOk={() => {
          setBillCodeDetailVisible(false)
          setDetailParam([])
        }}
        onCancel={() => {
          setBillCodeDetailVisible(false)
          setDetailParam([])
        }}></BillCodeDetailModal>
    </>
  )
}
